import { render, staticRenderFns } from "./adcarouselsmall.vue?vue&type=template&id=47046c8f&scoped=true"
import script from "./adcarouselsmall.vue?vue&type=script&lang=js"
export * from "./adcarouselsmall.vue?vue&type=script&lang=js"
import style0 from "./adcarouselsmall.vue?vue&type=style&index=0&id=47046c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47046c8f",
  null
  
)

export default component.exports